/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import FormField from '../../../../client/js/components/form/fields/FormField'
import {
  TRANSACTION_RENTAL,
  TRANSACTION_SALE,
  TRANSACTION_SEASONAL_RENTAL
} from '../../enums/TransactionCodes.mjs'
import { Select, SelectProps } from '@mantine/core'

export type TransactionFieldProps = Omit<SelectProps, 'data'>

function TransactionField (props: TransactionFieldProps) {
  const { name = 'transaction', ...others } = props
  const intl = useIntl()
  return (
    <FormField
      allowDeselect={false}
      name={name}
      label={intl.formatMessage({
        id: 'transaction',
        defaultMessage: 'Transaction'
      })}
      render={Select}
      data={[
        {
          label: intl.formatMessage({
            id: 'rental',
            defaultMessage: 'Location'
          }),
          value: TRANSACTION_RENTAL
        },
        {
          label: intl.formatMessage({
            id: 'seasonal_rental',
            defaultMessage: 'Location saisonnière'
          }),
          value: TRANSACTION_SEASONAL_RENTAL
        },
        {
          label: intl.formatMessage({
            id: 'sale',
            defaultMessage: 'Vente'
          }),
          value: TRANSACTION_SALE
        }
      ]}
      {...others}
    />
  )
}

export default TransactionField
